// import Sockette from "sockette"
//
// import { WebsocketBuilder } from "websocket-ts"
// import { Websocket } from "websocket-ts/src/websocket"

// export type Socket = {
//   send: (data: object) => void
//   on: (name: string) => void
// }

import { w3cwebsocket as W3CWebSocket } from "websocket"

type RecvEvent = (data: any) => void
export class Socket {
  private isConnect: boolean
  private client: W3CWebSocket
  private events: RecvEvent[]

  constructor() {
    this.events = []
    this.isConnect = false
  }

  get connected() {
    return this.isConnect
  }

  connect(token) {
    const WSURL = `${process.env.NEXT_PUBLIC_WS_URL}?token=${token}`
    this.client = new W3CWebSocket(WSURL)
    this.client.onerror = function () {
      console.log("Connection Error")
    }

    //@ts-ignore
    this.client.onopen = (event) => {
      console.log("WebSocket Client Connected", this.client, event)
      setInterval(() => {
        this.client.send(
          JSON.stringify({
            origin: process.env.DOMAIN,
            action: "sendmessage",
            targetType: "ping",
          })
        )
      }, 3 * 60 * 1000)
      this.isConnect = true
    }

    this.client.onclose = (event) => {
      console.log("Client Closed", event)
    }

    this.client.onmessage = (e) => {
      console.log(this.events)
      if (typeof e.data === "string") {
        for (const recvEvent of this.events) {
          recvEvent?.call(null, JSON.parse(e.data))
        }
        console.log("Received", JSON.parse(e.data))
        // socket.recv?.call(this, JSON.parse(e.data))
      }
    }
  }

  send(data: object) {
    this.client.send(JSON.stringify(data))
  }

  notify(callback: RecvEvent) {
    this.events.push(callback)

    // this.client.send(JSON.stringify(data))
  }
  unNotify() {
    this.events.length = 0
  }

  // off(name:string) {
  //   this.client.send(JSON.stringify(data))
  // }
}
